import React, { Fragment } from 'react';
import OrdersList from '../forms/user-order-history/order-history-display/OrdersList';
import FileSummary from '../forms/user-order-history/file-summary-display/FileSummary';
import FileContentSummary from '../forms/user-order-history/file-summary-display/FileContentSummary';
import PaymentSummary from '../forms/user-order-history/file-summary-display/PaymentSummary';
import ChangeHistorySection from '../forms/user-order-history/file-summary-display/ChangeHistorySection';

export const orderHistoryFormConstants = {
    /* eslint-disable */
    orderHistoryDisplayForm: ({
        formData,
        displayCancelledFiles,
        orderHistoryData,
        orderHistoryPages,
        orderHistoryActivePageNumber,
        handleViewFileDetailsClick,
        handleDisplayCancelledFilesChange,
        handlePageNumberChange }) => {
        const { orderType } = formData;
        return <OrdersList
            formData={formData}
            displayCancelledFiles={displayCancelledFiles}
            orders={orderHistoryData}
            orderTypeValues={orderType}
            numberOfPages={orderHistoryPages}
            orderHistoryActivePageNumber={orderHistoryActivePageNumber}
            onViewFileDetailsClick={handleViewFileDetailsClick}
            handleDisplayCancelledFilesChange={handleDisplayCancelledFilesChange}
            handlePageNumberChange={handlePageNumberChange}></OrdersList>
    },
    fileDetailsDisplayForm: ({
        formData,
        orderHistoryForDisplay,
        handlePrintSummaryButton,
        handlePrintDocumentInvoiceButtonClick,
        handleCloseFormButton,
        handlePayReservationClick
    }) => {
        const {
            noProductsFoundText,
            noPaymentSummaryFoundText,
            noHistoryDataFoundText,
            country,
            fileState,
            orderType,
            showCancelButton } = formData;
        const { files, paymentSummary, history } = orderHistoryForDisplay;
        return <Fragment>
            <FileSummary
                orderItem={orderHistoryForDisplay}
                orderTypeValues={orderType}
                fileStateValues={fileState}
                onPrintSummaryButtonClick={handlePrintSummaryButton}
                onCancelButtonClick={handleCloseFormButton}
                onCloseButtonClick={handleCloseFormButton}
                onPayReservationClick={handlePayReservationClick}
                showCancelButton={showCancelButton}
                ></FileSummary>
            <div className='category order-history'>
                <FileContentSummary
                    fileContents={files}
                    noProductsFoundText={noProductsFoundText}></FileContentSummary>
                <PaymentSummary
                    paymentSummary={paymentSummary}
                    country={country}
                    noPaymentSummaryFoundText={noPaymentSummaryFoundText}></PaymentSummary>
                <ChangeHistorySection
                    historyContents={history}
                    orderTypeValues={orderType}
                    onPrintDocumentInvoiceButtonClick={handlePrintDocumentInvoiceButtonClick}
                    noHistoryDataFoundText={noHistoryDataFoundText}></ChangeHistorySection>
            </div>  
        </Fragment>
    },
    /* eslint-enable */
};
